module.exports = __webpack_public_path__ + "ef5997845b3b38a66c56485ef1088024.webm";